import { _t, tracking as barkTrackingLogEvent } from '@bark/bark-core';
import { Button as SellerButton } from '../seller-toolbar/toolbar_button';

export const whatsappResponseLogTrackingEvent = (eventName, data) => {
	barkTrackingLogEvent('seller-leads-dashboard-&-responses', eventName, {
		seller_profile_id: data?.sellerProfileId,
		project_id: data?.projectId,
		response_id: data?.projectResponseId,
		page: window.location.pathname,
	});
};

export const addWhatsappResponseButton = (whatsappResponseFeedbackModal) => {
	const { Handlebars } = window;
	const SellerResponseFlowButtonTemplate = Handlebars.compile(
		document.getElementById('seller-response-flow-button-template').innerHTML,
	);
	return new SellerButton({
		name: 'seller-whatsapp',
		template: SellerResponseFlowButtonTemplate,
		label: _t('seller_response_flow:whatsapp.title'),
		params: {},
		callback: () => {
			sendMessageFromWhatsapp(
				whatsappResponseFeedbackModal.getFromState('buyerNumberFormatted'),
			);
			whatsappResponseFeedbackModal.show();
			whatsappResponseLogTrackingEvent(
				'whatsapp - button',
				{
					sellerProfileId: whatsappResponseFeedbackModal.getFromState('sellerProfileId'),
					projectId: whatsappResponseFeedbackModal.getFromState('projectId'),
					projectResponseId:
						whatsappResponseFeedbackModal.getFromState('projectResponseId'),
				},
			);
			if (Bark?.sellerResponseFlow) {
				Bark.sellerResponseFlow.completeTask('whatsapp');
			}
		},
		conditions: [
			() =>
				whatsappResponseFeedbackModal.getFromState('buyerNumberFormatted') &&
				['api', 'manual'].includes(Bark?.sellerResponseFlow?.smsData?.smsType),
		],
		container_class: 'response-button-whatsapp-container',
	});
};

export const sendMessageFromWhatsapp = (number, message = '') => {
	const whatsappUrl = `https://wa.me/${number}?text=${message}`;
	window.open(whatsappUrl, '_blank');
};

